import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap-5';

import ConfigurableEnumForm from './form';
import Errors from 'components/form/errors';
import { save } from 'components/configurable_enums/api';

export default class ConfigurableEnumModal extends React.Component {
  static propTypes = {
    basePath: PropTypes.string.isRequired,
    enumValue: PropTypes.shape({
      id: PropTypes.number,
      type: PropTypes.string
    }).isRequired,
    formLabel: PropTypes.string,
    modalTitle: PropTypes.string,
    show: PropTypes.bool,

    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  }

  static defaultProps = {
    modalTitle: 'Value'
  }

  state = {
    errors: [],
    enumValue: {},
    saving: false
  }

  componentDidUpdate(previousProps) {
    if (this.props.show && !previousProps.show) {
      this.setState({
        errors: [],
        saving: false,
        enumValue: { ...this.props.enumValue }
      });
    }
  }

  handleChange = (changes) => {
    this.setState(({ enumValue }) => ({ enumValue: { ...enumValue, ...changes } }));
  }

  handleSave = () => {
    this.setState({ errors: [], saving: true });

    save(this.props.basePath, this.state.enumValue)
      .then(this.props.onSave)
      .catch(errors => this.setState({ errors, saving: false }));
  }

  render() {
    const { formLabel, onCancel, show } = this.props;
    const { errors, enumValue } = this.state;

    return (
      <Modal
        show={show}
        onHide={onCancel}
      >
        <Modal.Header closeButton>
          <Modal.Title>{enumValue.id ? 'Edit' : 'Add'} {this.props.modalTitle}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Errors className="mb-3" errors={errors}/>
          <ConfigurableEnumForm
            enumValue={enumValue}
            formLabel={formLabel}
            onChange={this.handleChange}
          />
        </Modal.Body>

        <Modal.Footer>
          <Button name="cancel" variant="cancel" onClick={onCancel}>
            Cancel
          </Button>

          <Button
            disabled={this.state.saving}
            name="save"
            variant="primary"
            onClick={this.handleSave}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
